<template>
  <section>
    <v-tabs dark slider-color="red">
      <v-tab
        v-for="tab in tabs"
        :key="`tab-${tab.route}`"
        ripple
        :to="{ name: tab.route }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-card class="px-4 py-4">
      <router-view />
    </v-card>
  </section>
</template>

<script>
export default {
  name: 'SponsorsSettings',
  data () {
    return {
      tabs: [
        {
          name: 'Types of sponsors',
          route: 'types'
        },
        {
          name: 'Tasks of sponsors',
          route: 'tasks'
        },
        {
          name: 'Tiers of sponsors',
          route: 'tiers'
        },
        {
          name: 'Media Kits',
          route: 'media-kits'
        },
        {
          name: 'Media Kits Page Settings',
          route: 'media-kits-settings'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/index.vue